import axios from "axios";
import {
  ScrapeConfig,
  ScrapeRun,
  AtsOption,
  CreateScrapeConfig,
  UpdateScrapeConfig,
  ScrapeConfigFilters,
} from "../../Types/Scrapes";

const BASE = import.meta.env.VITE_BACKEND_API + "/api/Scrape";

export const getScrapeConfigs = (filters?: ScrapeConfigFilters): Promise<ScrapeConfig[]> => {
  const params = new URLSearchParams();
  if (filters?.clientId) params.append("clientId", filters.clientId);
  if (filters?.atsId) params.append("atsId", filters.atsId);
  if (filters?.isActive !== null && filters?.isActive !== undefined)
    params.append("isActive", String(filters.isActive));

  const query = params.toString();
  return axios.get<ScrapeConfig[]>(`${BASE}/configs${query ? `?${query}` : ""}`).then((res) => res.data);
};

export const getScrapeConfig = (id: string): Promise<ScrapeConfig> => {
  return axios.get<ScrapeConfig>(`${BASE}/configs/${id}`).then((res) => res.data);
};

export const createScrapeConfig = (data: CreateScrapeConfig): Promise<ScrapeConfig> => {
  return axios.post<ScrapeConfig>(`${BASE}/configs`, data).then((res) => res.data);
};

export const updateScrapeConfig = (id: string, data: UpdateScrapeConfig): Promise<ScrapeConfig> => {
  return axios.put<ScrapeConfig>(`${BASE}/configs/${id}`, data).then((res) => res.data);
};

export const deleteScrapeConfig = (id: string): Promise<void> => {
  return axios.delete(`${BASE}/configs/${id}`).then(() => undefined);
};

export const triggerScrapeRun = (id: string): Promise<void> => {
  return axios.post(`${BASE}/configs/${id}/run`).then(() => undefined);
};

export const getScrapeRuns = (id: string): Promise<ScrapeRun[]> => {
  return axios.get<ScrapeRun[]>(`${BASE}/configs/${id}/runs`).then((res) => res.data);
};

export const getScrapeRunXml = (id: string, blobName: string): Promise<string> => {
  return axios
    .get<string>(`${BASE}/configs/${id}/runs/${encodeURIComponent(blobName)}/xml`)
    .then((res) => res.data);
};

export const getAtsOptions = (): Promise<AtsOption[]> => {
  return axios.get<AtsOption[]>(`${BASE}/ats`).then((res) => res.data);
};
